var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1499 0H7.85002C3.52145 0 0 3.43341 0 7.65377V20.6214C0 24.8415 3.52145 28.2749 7.85002 28.2749H21.1501C25.4785 28.2749 28.9999 24.8415 28.9999 20.6214V7.65377C28.9999 3.43341 25.4785 0 21.1499 0V0ZM27.2998 20.6214C27.2998 23.9275 24.5411 26.6173 21.1499 26.6173H7.85002C4.45889 26.6173 1.7001 23.9275 1.7001 20.6214V7.65377C1.7001 4.34742 4.45889 1.6576 7.85002 1.6576H21.1501C24.5411 1.6576 27.2998 4.34742 27.2998 7.65377V20.6214Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.40625C10.1276 6.40625 6.57056 9.87439 6.57056 14.1375C6.57056 18.4005 10.1276 21.8687 14.5 21.8687C18.8724 21.8687 22.4295 18.4005 22.4295 14.1375C22.4295 9.87439 18.8724 6.40625 14.5 6.40625ZM14.5 20.2111C11.0653 20.2111 8.27066 17.4865 8.27066 14.1375C8.27066 10.7886 11.0653 8.06385 14.5 8.06385C17.9349 8.06385 20.7294 10.7886 20.7294 14.1375C20.7294 17.4865 17.9349 20.2111 14.5 20.2111Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6191 3.66055C21.3269 3.66055 20.276 4.68544 20.276 5.94503C20.276 7.20484 21.3269 8.22973 22.6191 8.22973C23.9112 8.22973 24.9623 7.20484 24.9623 5.94503C24.9623 4.68523 23.9112 3.66055 22.6191 3.66055ZM22.6191 6.57192C22.2646 6.57192 21.9761 6.29062 21.9761 5.94503C21.9761 5.59923 22.2646 5.31815 22.6191 5.31815C22.9737 5.31815 23.2622 5.59923 23.2622 5.94503C23.2622 6.29062 22.9737 6.57192 22.6191 6.57192Z",
    fill: "#919191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28.275,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18);
export default __webpack_public_path__ + "static/media/Group-18.d8788ebd0621b8bc004ce1c16af94973.svg";
export { ForwardRef as ReactComponent };